import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Components/Home";
import Experience from "./Components/Exprience";
import Contact from "./Components/Contact";
// import Casestudy from "./Components/Casestudy";
import Error from "./Components/Error";
import Menu from "./Components/Menu";
import {Footer} from "./Components/Footer";
// import Profile from "./Components/Profile";
//import Slide from "./Components/Slide";
//import { Skills } from "./Components/Skills";
//import { Tools } from "./Components/Tools";

const App=()=> {
  return(
    <div className="">
    <BrowserRouter>
    <Menu />
    <Routes>
      <Route path="/" element={<Home/>}/>
      {/* <Route path="/casestudy" element={<Casestudy/>}/> */}
      <Route path="/experience" element={<Experience/>}/>
      <Route path="/contact" element={<Contact/>}/>
      <Route path="*" element={<Error/>}/>
    </Routes>
    <Footer/>
    </BrowserRouter>
    </div>
  )
}

export default App;